

























import Vue from "vue";
import PROJECTS from "@/graphql/projects/Projects.gql";
import { Projects_projects_edges } from "@/api-types";

export default Vue.extend({
  name: "Projects",
  apollo: {
    projects: {
      query: PROJECTS
    }
  },
  methods: {
    hasAccess: function(projectEdge: Projects_projects_edges) {
      let hasTool = false;
      Object.entries(projectEdge!.node!).forEach(([__, v]) => {
        if (v && this.$store.state.toolIds.includes(v.id) && v.active) {
          hasTool = true;
          return;
        }
      });
      return hasTool;
    }
  },
  mounted() {
    document.title = "Hydromapper - Projekte";
    this.$store.commit("setToolbarTitle", "Projekte");
  }
});
